import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { UaService } from '@ecm/consumer';

import { AbstractComponent } from '../shared/abstract.component';

@Component({
    selector: 'ecm-mat-visitor-home',
    templateUrl: 'material-visitor-home.html',
    styleUrls: ['material-visitor-home.css'],
})
export class MaterialVisitorHomeComponent extends AbstractComponent implements OnInit {
    /**
     * i18n root path
     * @type {string}
     */
    public i18nPath = 'material.visitor.home.links';

    /**
     * Background image url
     * @type {string}
     */
    @Input() public backgroundImageUrl: string;

    /**
     * Background height (override css default rule)
     * @type {number?}
     */
    @Input() public backgroundImageHeight?: number;

    /**
     * Main title
     * @type {string}
     */
    @Input() public title: string;

    /**
     * Description
     * @type {string? | string[]?}
     */
    @Input() public description?: string | string[];

    /**
     * Authenticate button label
     * @type {string?}
     */
    @Input() public confirmationLabel?: string;

    /**
     * Reason title
     * @type {string?}
     */
    @Input() public reasonTitle?: string;

    /**
     * Reason Sub title
     * @type {string?}
     */
    @Input() public reasonSubTitle?: string;

    /**
     * Reasons
     * @type {string[]?}
     */
    @Input() public reasons?: string[];

    /**
     * Reason Information
     * @type {string?}
     */
    @Input() public reasonInformation?: string;

    /**
     * Widget title
     * @type {string?}
     */
    @Input() public widgetTitle?: string;

    /**
     * Widget Information
     * @type {string?}
     */
    @Input() public widgetInformation?: string;

    /**
     * Widgets
     * @type {{picture: string, alt: string, title: string, description: string}[]?}
     */
    @Input() public widgets?: Array<{ picture: string; alt?: string; title: string; description: string }>;

    /**
     * Data-e2e tag
     * @type {string} e2e
     */
    @Input() public e2e?: string;

    /**
     * if indentifiant should be displayed
     * @type {boolean}
     */
    @Input() public isIdentifierLinkDisplayed = true;

    /**
     * Login requested event
     * @type {EventEmitter<any>}
     */
    @Output() public materialVisitorHomeLogin: EventEmitter<any> = new EventEmitter<any>();

    /**
     * Find identifier event
     * @type {EventEmitter<any>}
     */
    @Output() public materialVisitorHomeFindIdentifier: EventEmitter<any> = new EventEmitter<any>();

    public constructor(protected uaService: UaService) {
        super(uaService);
    }

    /**
     * @inheritDoc
     */
    public ngOnInit(): void {
        super.init();

        // set e2e data tag
        this.e2e = this.e2e || 'e2e-material-visitor-home';
    }

    /**
     * Emit event when "Où trouver vos identifiants" link is click
     */
    public emitFindIdentifierEvent(): void {
        this.materialVisitorHomeFindIdentifier.emit();
    }

    /**
     * Emit event when "S'identifier" link is click
     */
    public emitLoginEvent(): void {
        this.materialVisitorHomeLogin.emit();
    }

    /**
     * Get background height
     * @returns {string}
     */
    public get backgroundImageStyleHeight(): string {
        return this.backgroundImageHeight && !this.isUserAgentMobile ? this.backgroundImageHeight + 'px' : '';
    }

    /**
     * Wrapper to cast string as string[]
     * @returns {string[]}
     */
    public stringArrayFormatter(text: string | string[]): string[] {
        return typeof text === 'string' ? [text] : text;
    }
}
